import { Folder, SaveFolderInput, SetReportFolderInput, SetScheduleFolderInput } from '@core/types';
import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';

/** Get All User Folders */
export const getAllUserFolders = createAction('[User Folders] Get All User Folders');
export const getAllUserFoldersSuccess = createAction('[User Folders] Get All User Folders Success', props<{ folders: Folder[] }>());

/** Create New or Update Folder */
export const saveUserFolder = createAction('[User Folders] Create New or Update Folder', props<{ folder: SaveFolderInput }>());
export const createUserFolderSuccess = createAction('[User Folders] Create New Folder Success', props<{ folder: Folder }>());
export const updateUserFolderSuccess = createAction('[User Folders] Update Folder Success', props<{ folder: Update<Folder> }>());

/** Delete User Folder */
export const deleteUserFolder = createAction('[User Folders] Delete User Folder', props<{ id: string }>());
export const deleteUserFolderSuccess = createAction('[User Folders] Delete User Folder Success', props<{ id: string }>());
export const deleteUserFolderError = createAction('[User Folders] Delete User Folder Error', props<{ id: string }>());

/** Create a temporary folder to add on the tree and edit */
export const createFolderForSaving = createAction('[User Folders] Create Folder For Saving', props<{ folder: Folder }>());
export const removeFolderForSaving = createAction('[User Folders] Remove Folder For Saving');

/** Set report folder */
export const setReportFolder = createAction('[User Folders] Set report folder', props<{ reportFolderInput: SetReportFolderInput }>());
/** Set schedule folder */
export const setScheduleFolder = createAction('[User Folders] Set schedule folder', props<{ scheduleFolderInput: SetScheduleFolderInput }>());
/** Set last saved folder id */
export const setLastSavedFolderId = createAction('[User Folders] Set last saved folder id', props<{ lastSavedFolderId: string | undefined }>());
